(function () {
    'use strict';

    angular
        .module('app.errorPage')
        .run(configureRoutes);

    function configureRoutes(routeManager) {
        routeManager.addStates([
            {
                state: 'errorPage',
                config: {
                    templateUrl: 'app/errorPage/error-page.html',
                    url: '/errorPage'
                }
            }
        ]);
    }
})();